import { useState } from "react";
import { billingStore } from "../billing/billingStore";
import { MatchCelebration } from "./MatchCelebration";
import { matchStore } from "./matchStore";
import type { MatchProfile, MatchRecord } from "./types";
import { useT } from "../i18n";

export function WhoLikedPage({
  onOpenChat,
}: {
  onOpenChat: (matchId: string) => void;
}) {
  const t = useT();
  const [, setTick] = useState(0);
  const [hit, setHit] = useState<{
    profile: MatchProfile;
    record: MatchRecord;
  } | null>(null);
  const self = matchStore.getState().self;
  const billing = billingStore.get();
  const isGuest = Boolean(self?.id.startsWith("user_guest_"));
  const whoLiked = matchStore.listWhoLikedYou();
  const canSee = Boolean(isGuest || billing.canSeeWhoLikedYou);

  if (!self) return null;

  if (hit) {
    return (
      <MatchCelebration
        self={self}
        other={hit.profile}
        record={hit.record}
        onContinue={() => {
          setHit(null);
          setTick((n) => n + 1);
        }}
        onOpenChat={onOpenChat}
      />
    );
  }

  const rows = whoLiked;

  return (
    <div className="match-list match-who-page screen-enter">
      <h1>{t("match.whoLikedTitle")}</h1>
      <p className="match-list__sub">{t("match.whoLikedHint")}</p>
      {!canSee ? (
        <p className="match-empty__meta" role="status">
          {t("match.whoLikedLocked")}
        </p>
      ) : null}
      {canSee && rows.length === 0 ? (
        <p className="match-empty__meta">{t("match.whoLikedEmpty")}</p>
      ) : null}
      {canSee && rows.length > 0 ? (
        <ul className="match-who-page__list">
          {rows.map((p) => (
            <li key={p.id} className="match-who-page__card">
              {p.photoUrl ? (
                <img
                  className="match-who-page__photo"
                  src={p.photoUrl}
                  alt=""
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = "none";
                  }}
                />
              ) : (
                <span className="match-who-page__mono" aria-hidden>
                  {p.firstName.slice(0, 1)}
                </span>
              )}
              <div className="match-who-page__body">
                <strong>
                  {t("match.personLine", { name: p.firstName, age: p.age })}
                </strong>
                <span>{p.city}</span>
                {p.aboutYou ? <p>{p.aboutYou}</p> : null}
                <button
                  type="button"
                  className="match-act match-act--like match-act--heart"
                  onClick={() => {
                    void matchStore.like(p.id).then((record) => {
                      if (record) setHit({ profile: p, record });
                      else setTick((n) => n + 1);
                    });
                  }}
                >
                  {t("match.likeBack")}
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
